import { DEFAULT_PAGE } from 'utils'

interface AppTypeConfig {
  defaultPage: string
  showSsoLogin: boolean
}

const config: AppTypeConfig = {
  defaultPage: DEFAULT_PAGE,
  showSsoLogin: true,
}

export default config
